(function($) {
    'use strict';

    let $body = $(document.body);

    $body.on('click', '.play-video', function() {
        var video_id = $(this).attr('data-video');
        var video = document.getElementById(video_id);

        if (video) {
            video.play();
        }
    });

    $body.on('click', '.stop-video', function() {
        var video_id = $(this).attr('data-video');
        var video = document.getElementById(video_id);

        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    });

}(jQuery));